<template>
  <div>
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="140px"
      class="demo-ruleForm fromdata"
    >
      <el-form-item
        :label="dataobjs.chuangandanyuanleixing"
        prop="unittype"
        style="width: 48%"
      >
        <el-input v-model="ruleForm.unittype"></el-input>
      </el-form-item>
      <el-form-item
        :label="dataobjs.chuangandanyuanyingwenming"
        prop="unittype_en"
        style="width: 48%"
      >
        <el-input v-model="ruleForm.unittype_en"></el-input>
      </el-form-item>
      <el-form-item
        :label="dataobjs.pinyinma"
        style="width: 48%"
        prop="pinyincode"
      >
        <el-input v-model="ruleForm.pinyincode"></el-input>
      </el-form-item>
      <!--  prop="unitcode" dataobjs.xiugaichuangandanyuan -->
      <el-form-item
        :label="dataobjs.shibiema"
        prop="unitcode"
        style="width: 48%"
      >
        <el-input v-model="ruleForm.unitcode"></el-input>
      </el-form-item>
      <!--  prop="unit" -->
      <el-form-item
        :label="dataobjs.shuzhidanwei"
        style="width: 48%"
        prop="unit"
      >
        <el-input v-model="ruleForm.unit"></el-input>
      </el-form-item>
      

          <el-form-item
        :label="dataobjs.yingwendanwei"
        style="width: 48%"
        prop="unit_en"
      >
        <el-input v-model="ruleForm.unit_en"></el-input>
      </el-form-item>
      <!--  prop="scale"  -->
      <el-form-item
        :label="dataobjs.huansuanxishu"
        style="width: 48%"
        prop="scale"
      >
        <el-input v-model="ruleForm.scale"></el-input>
      </el-form-item>
      <!-- prop="bytes" -->
      <el-form-item :label="dataobjs.zijieshu" style="width: 48%" prop="bytes">
        <el-input v-model="ruleForm.bytes"></el-input>
      </el-form-item>
      <!-- prop="decimaldigit" -->
      <el-form-item
        :label="dataobjs.xiaoshuweishu"
        style="width: 48%"
        prop="decimaldigit"
      >
        <!-- <el-input v-model="ruleForm.decimaldigit"></el-input> -->
        <el-select
          v-model="ruleForm.decimaldigit"
          placeholder="请选择"
          style="width: 100%"
          value-key="id"
        >
          <el-option
            v-for="item in optionsNumbere"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        :label="dataobjs.shangxian"
        style="width: 48%"
        prop="upperlimit"
      >
        <el-input v-model="ruleForm.upperlimit"></el-input>
      </el-form-item>
      <el-form-item
        :label="dataobjs.xiaxian"
        style="width: 48%"
        prop="lowerlimit"
      >
        <el-input v-model="ruleForm.lowerlimit"></el-input>
      </el-form-item>

      <el-form-item
        :label="dataobjs.shifoubuma"
        prop="iscomplement"
        style="width: 48%"
      >
        <el-select
          v-model="ruleForm.iscomplement"
          placeholder="请选择"
          style="width: 100%"
          value-key="id"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <!--     :on-preview="handlePictureCardPreview"
                :on-remove="handleRemove"
                :on-change="myings" -->
      <el-form-item label="上传图片：" label-width="150px">
        <!-- <el-input v-model="formLabelAlign.region"></el-input> -->
        <el-upload
          action="#"
          ref="upload"
          :file-list="flileImge"
          :auto-upload="false"
          list-type="picture-card"
          :on-change="myings"
          :on-remove="handleRemove"
          :on-preview="handlePictureCardPreview"
        >
          <i class="el-icon-plus"></i>
        </el-upload>
        <!-- <el-dialog :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrl" alt="" />
              </el-dialog> -->
      </el-form-item>
    </el-form>
    <div class="btenEtiel">
      <span slot="footer" class="dialog-footer addcentent">
        <el-button @click="dialogVisible('ruleForm')">{{
          dataobjs.quxiao
        }}</el-button>
        <el-button type="primary" @click="resetForm('ruleForm')">{{
          dataobjs.queding
        }}</el-button>
      </span>
    </div>
  </div>
</template>
<script>
import { sensingunitAdd, autoUpload } from "@/network/index";

export default {
  props: {
    diohide: {
      type: Function,
      default: Function,
    },
    ruleForm: {
      type: Object,
      default: {},
    },
    listcgdy: {
      type: Function,
      default() {
        return Function;
      },
    },
    flileImge: {
      type: Array,
      default: [],
    },
    dataobjs: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      options: [
        {
          value: "0",
          label: "否",
          id: 0,
        },
        {
          value: "1",
          label: "是",
          id: 1,
        },
      ],
      optionsNumbere: [
        {
          value: "-1",
          label: "-1",
          id: -1,
        },
        {
          value: "0",
          label: "0",
          id: 0,
        },
        {
          value: "1",
          label: "1",
          id: 1,
        },
        {
          value: "2",
          label: "2",
          id: 2,
        },
        {
          value: "3",
          label: "3",
          id: 3,
        },
      ],
      // flileImge:[],
      rules: {
        unittype: [
          { required: true, message: "请输入传感单元类型", trigger: "blur" },
        ],
        unittype_en: [
          {
            required: true,
            message: "请输入传感单元类型英文名称",
            trigger: "blur",
          },
        ],
        unitcode: [
          { required: true, message: "请输入传感单元识别码", trigger: "blur" },
        ],
        unit: [{ required: true, message: "请输入数值单位", trigger: "blur" }],
        scale: [{ required: true, message: "请输入换算系数", trigger: "blur" }],
        bytes: [{ required: true, message: "请输入字节数", trigger: "blur" }],
        decimaldigit: [
          { required: true, message: "请输入显示小数位数", trigger: "change" },
        ],
        iscomplement: [
          { required: true, message: "请选择是否补码", trigger: "change" },
        ],
        pinyincode: [
          { required: true, message: "请输入拼音码", trigger: "blur" },
        ],
        unit: [
          { required: true, message: "请输入数值单位码", trigger: "blur" },
        ],
        unit_en:[
          { required: true, message: "请输入数英文单位码", trigger: "blur" },
        ],
        scale: [{ required: true, message: "请输入换算系数", trigger: "blur" }],
        upperlimit: [
          { required: true, message: "请输入上限值", trigger: "blur" },
        ],
        lowerlimit: [
          { required: true, message: "请输入下限值", trigger: "blur" },
        ],
      },
    };
  },
  computed: {
    iconHane() {
      console.log(this.ruleForm);
    },
  },
  methods: {
    // 新增的方法
    addimgLint() {
      let a = document.getElementsByClassName("el-upload--picture-card")[0];
      a.style.display = "block";
    },
    // 上传图片
    async myings(file, fileList) {
      let files = file.raw;
      const lang_file = sessionStorage.getItem("lang_file");
      const token = sessionStorage.getItem("token");
      let fromData = new FormData();
      fromData.append("image", files);
      fromData.append("appid", token);
      fromData.append("lang_file", lang_file);
      const { code, data, msg } = await autoUpload(fromData);
      if (code) {
        this.ruleForm.icon = data;
        let a = document.getElementsByClassName("el-upload--picture-card")[0];
        a.style.display = "none";
      } else {
        this.$message.error(msg);
      }
    },
    hideLimg() {
      let a = document.getElementsByClassName("el-upload--picture-card")[0];
      a.style.display = "none";
    },
    showLimg() {
      let a = document.getElementsByClassName("el-upload--picture-card")[0];
      a.style.display = "block";
    },
    // 删除
    handleRemove() {
      this.ruleForm.icon = null;
      let a = document.getElementsByClassName("el-upload--picture-card")[0];
      a.style.display = "block";
    },
    handlePictureCardPreview(file) {
      // this.dialogImageUrl = file.url;
      // this.dialogVisible = true;
    },
    // 确定
    resetForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          if (this.ruleForm.uuid == undefined) {
            if (this.ruleForm.icon != "") {
              const { code, data, msg } = await sensingunitAdd(this.ruleForm);
              if (code) {
                this.diohide(); //关闭他弹框
                this.$message.success(msg);
                this.listcgdy();
                // this.$refs.upload.clearFiles();
              } else {
                this.$message.error(msg);
              }
            } else {
              this.$message.error("请上传图片");
            }
          } else {
            if (this.ruleForm.icon != null) {
              const { code, data, msg } = await sensingunitAdd(this.ruleForm);
              if (code) {
                this.diohide(); //关闭他弹框
                this.$message.success(msg);
                this.listcgdy();
              } else {
                this.$message.error(msg);
              }
            } else {
              this.$message.error("请上传图片");
            }
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    dialogVisible(formName) {
      //  this.$refs.rules.resetFields();
      this.diohide();
    },
  },
};
</script>
<style>
.el-form-item {
  margin-bottom: 10px;
}
.addcentent {
  display: flex;
  justify-content: center;
}
.fromdata {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.fromdata .el-upload-list--picture-card .el-upload-list__item {
  background: red !important;
}
</style>